module.exports = __webpack_public_path__ + "static/media/icon-folder.2240aa50.svg";